/**
 * Do not edit directly
 */

export default "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ij48cGF0aCBkPSJNOC41LDEuM0w3LjgsMkwxMy44LDhMNy44LDE0TDguNSwxNC43TDE1LjIsOEw4LjUsMS4zWiBNMS41LDEuM0wwLjgsMkw2LjgsOEwwLjgsMTRMMS41LDE0LjdMOC4yLDhMMS41LDEuM1oiLz48L3N2Zz4=";